import 'react-datepicker/dist/react-datepicker.css';

import React, { forwardRef, useState } from 'react';
import DatePicker from 'react-datepicker';

type Props = {
  text: string;
  onChangeDate: (date: string) => void;
  value?: Date;
};

const DatePickerButton = (props: Props) => {
  const [startDate, setStartDate] = useState(props.value ? props.value : new Date());

  const convertDate = (originalDate: string) => {
    const dateParts: any[] = originalDate.split('/');
    const date = new Date(dateParts[2], dateParts[0] - 1, dateParts[1]); // Month is zero-based

    // Format the date as 'DD Month'
    const options: any = { day: 'numeric', month: 'long' };
    const formattedDate = date.toLocaleDateString('en-US', options);

    return formattedDate;
  };

  const handleDateChange = (date: Date) => {
    // Extract the year, month, and day
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Month is zero-based, so add 1
    const day = String(date.getDate()).padStart(2, '0');
    // Format the date as YYYY-MM-DD
    const formattedDate = `${year}-${month}-${day}`;
    props.onChangeDate(formattedDate);
  };

  const ExampleCustomInput = forwardRef<any, any>(({ value, onClick, className }: any, ref: any) => (
    <div
      onClick={onClick}
      onKeyDown={e => e.key === 'Enter' && onClick?.(e)}
      role="button"
      tabIndex={0}
      ref={ref}
      className="tw-cursor-pointer tw-w-[170px]   tw-h-8 tw-pl-2.5 tw-pr-3 tw-py-1.5 tw-bg-white tw-rounded-full tw-shadow-sm tw-border tw-border-gray-300 tw-justify-between tw-items-center tw-gap-2 tw-inline-flex tw-overflow-hidden"
    >
      <div className="tw-text-gray-500 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{props.text}</div>
      <div className="tw-text-gray-800 tw-text-sm tw-font-normal tw-font-['Lexend'] tw-leading-tight">{convertDate(value)}</div>
    </div>
  ));

  ExampleCustomInput.displayName = 'ExampleCustomInput';

  return (
    <DatePicker
      selected={startDate}
      onChange={(date: any) => {
        setStartDate(date);
        handleDateChange(date);
      }}
      customInput={<ExampleCustomInput className="example-custom-input" />}
    />
  );
};

export default DatePickerButton;
